import React, { useState, useRef, useEffect } from "react";
import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc =
  "/pdf.worker.min.mjs";

function PdfStep({
    pdf,
    completed,
    onComplete,
}) {
    const [numPages, setNumPages] =
        useState(null);

    // const [pageWidth, setPageWidth] =
    //     useState(800);

    const [hasUserScrolled, setHasUserScrolled] =
        useState(false);

    const containerRef = useRef(null);

    // useEffect(() => {
    //     function updateWidth() {
    //         if (containerRef.current) {
    //             setPageWidth(
    //                 Math.min(
    //                     containerRef.current.offsetWidth -
    //                     40,
    //                     300
    //                 )
    //             );
    //         }
    //     }

    //     updateWidth();

    //     window.addEventListener(
    //         "resize",
    //         updateWidth
    //     );

    //     return () => {
    //         window.removeEventListener(
    //             "resize",
    //             updateWidth
    //         );
    //     };
    // }, []);

    // Reset scroll state when PDF changes
    useEffect(() => {
        setHasUserScrolled(false);

        if (containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, [pdf.id]);

    function onDocumentLoadSuccess({
        numPages,
    }) {
        setNumPages(numPages);

        requestAnimationFrame(() => {
            const container =
                containerRef.current;

            if (!container) return;

            container.scrollTop = 0;

            const isScrollable =
                container.scrollHeight >
                container.clientHeight;

            // If no scrolling needed,
            // auto-complete document
            if (!isScrollable && !completed) {
                onComplete(pdf.id);
            }
        });
    }

    const handleScroll = (e) => {
        const container = e.target;

        // User actually interacted
        if (!hasUserScrolled) {
            setHasUserScrolled(true);
        }

        const scrollPosition =
            container.scrollTop +
            container.clientHeight;

        const threshold =
            container.scrollHeight - 20;

        // Prevent auto-complete on mount
        if (
            hasUserScrolled &&
            scrollPosition >= threshold &&
            !completed
        ) {
            onComplete(pdf.id);
        }
    };

    return (
        <div>
            <div
                ref={containerRef}
                onScroll={handleScroll}
                style={{
                    height: 300,
                    overflowY: "auto",
                    minHeight: 0,
                    border: "1px solid #ccc",
                }}
            >
                <Document
                    file={pdf.url}
                    onLoadSuccess={
                        onDocumentLoadSuccess
                    }
                    loading={<p>Loading PDF...</p>}
                >
                    {Array.from(
                        new Array(numPages),
                        (_, index) => (
                            <div
                                key={index}
                                style={{
                                    marginBottom: 20,
                                    display: "flex",
                                    justifyContent:
                                        "center",
                                }}
                            >
                                <Page
                                    pageNumber={index + 1}
                                    scale={0.6}
                                    renderTextLayer={false}
                                    renderAnnotationLayer={
                                        false
                                    }
                                />
                            </div>
                        )
                    )}
                </Document>
            </div>
        </div>
    );
}

export default function RulesAcceptance({
    pdfs,
    onAccepted,
    closeModal,
}) {
    const [completedDocs, setCompletedDocs] =
        useState([]);

    const [currentIndex, setCurrentIndex] =
        useState(0);

    const currentPdf = pdfs[currentIndex];

    const isLastPdf =
        currentIndex === pdfs.length - 1;

    const currentCompleted =
        completedDocs.includes(currentPdf.id);

    const allComplete = pdfs.every((pdf) =>
        completedDocs.includes(pdf.id)
    );

    const [signature, setSignature] = useState("");


    const handleComplete = (docId) => {
        setCompletedDocs((prev) => {
            if (prev.includes(docId)) {
                return prev;
            }

            return [...prev, docId];
        });
    };

    const handleNext = () => {
        if (
            currentCompleted &&
            !isLastPdf
        ) {
            setCurrentIndex((prev) => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (currentIndex > 0) {
            setCurrentIndex((prev) => prev - 1);
        }
    };

    return (
        <div className="rulesDocumentsContainer">

            <div
                style={{
                    marginBottom: 20,
                    display: "flex",
                    flexDirection: "row"
                }}
            >
                <p style={{ flex: 1 }}>Rules {currentIndex + 1} of{" "}{pdfs.length}</p>
                <div className="closeButtonContainer">
                    <button
                        onClick={() => closeModal()}
                        className="closeButton">X</button>
                </div>
            </div>
            <PdfStep
                pdf={currentPdf}
                completed={currentCompleted}
                onComplete={handleComplete}
            />
            {isLastPdf && (
                <div style={{ marginTop: 20 }}>
                    <label style={{ display: "block", marginBottom: 8 }}>
                        Type your full name to accept:
                    </label>

                    <input
                        type="text"
                        value={signature}
                        onChange={(e) =>
                            setSignature(e.target.value)
                        }
                        disabled={!allComplete}
                        placeholder={
                            allComplete
                                ? "Your full name"
                                : "Scroll to the end to enable"
                        }
                        style={{
                            padding: "10px",
                            width: "100%",
                            maxWidth: 400,
                            border: "1px solid #ccc",
                            opacity: allComplete
                                ? 1
                                : 0.5,
                        }}
                    />
                </div>
            )}

            {/* Pager Controls */}
            <div
                style={{
                    width: '100%',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 12,
                }}
            >
                <button
                    className="pagerButton"
                    onClick={handlePrevious}
                    disabled={currentIndex === 0}
                >
                    Previous
                </button>

                {!isLastPdf && (
                    <button
                        className="pagerButton"
                        onClick={handleNext}
                        disabled={!currentCompleted}
                        style={{
                            background:
                                currentCompleted
                                    ? "green"
                                    : "gray",
                            color: "white",
                            border: "none",
                            padding:
                                "10px 20px",
                            cursor:
                                currentCompleted
                                    ? "pointer"
                                    : "not-allowed",
                        }}
                    >
                        Next Document
                    </button>
                )}

                {isLastPdf && (
                    <button
                        className="pagerButton"
                        disabled={!allComplete && signature === ""}
                        onClick={() => onAccepted(signature)}
                        style={{
                            padding:
                                "10px 20px",
                            background:
                                (allComplete && signature !== "")
                                    ? "green"
                                    : "gray",
                            color: "white",
                            border: "none",
                            cursor:
                                (allComplete && signature !== "")
                                    ? "pointer"
                                    : "not-allowed",
                        }}
                    >
                        I Agree to the Rules
                    </button>
                )}
            </div>
        </div>
    );
}